import { HStack, Text } from "@chakra-ui/react";
import { AwakenTooltip } from "src/components";
import { colors } from "src/theme";

export const TaxForms = () => {
  return (
    <HStack>
      <HStack>
        {/*  */}
        <HStack
          style={{
            padding: 2,
            background: `rgba(0,0,0,0.8)`,
            border: `1px solid ${colors.gray20}`,
            borderRadius: 100,
            overflow: "hidden",
            paddingRight: 10,
          }}
        >
          <img
            src={require("src/assets/awaken/icons/turbotax.png")}
            alt="TurboTax"
            style={{
              borderRadius: 50,
              width: "1.5rem",
              height: "1.5rem",
            }}
          />
          <Text color={colors.white} fontSize="sm" fontWeight="medium">
            TurboTax
          </Text>
        </HStack>
        <AwakenTooltip message="All the IRS forms you need including: 8949, 1099B, Schedule D, Schedule 1, & more.">
          <HStack
            style={{
              padding: 2,
              background: `rgba(0,0,0,0.8)`,
              border: `1px solid ${colors.gray20}`,
              borderRadius: 100,
              overflow: "hidden",
              paddingRight: 10,
            }}
          >
            <div
              style={{
                width: "1.5rem",
                height: "1.5rem",
                backgroundColor: "white",

                borderRadius: 100,
              }}
            >
              <img
                src={require("src/assets/awaken/icons/irs.png")}
                alt="IRS"
                style={{
                  objectFit: "cover",
                  width: "100%",
                  height: "100%",
                }}
              />
            </div>
            <Text color={colors.white} fontSize="sm" fontWeight="medium">
              8949, 1099B, & more
            </Text>
          </HStack>
        </AwakenTooltip>
      </HStack>
    </HStack>
  );
};
